export default "__VITE_ASSET__f3b52f3b__"